import { Navigate, Outlet, useLocation } from 'react-router';
import { useSesion } from '@/shared/sesion/SesionProvider';

export function RutaProtegida() {
  const { perfil, cargando } = useSesion();
  const ubicacion = useLocation();

  if (cargando) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-armazon-500">
        Cargando…
      </div>
    );
  }

  if (!perfil) {

    return <Navigate to="/acceso" replace state={{ destino: ubicacion.pathname }} />;
  }

  return <Outlet />;
}
